import { PartnershipDetails } from '@urbanx/agx.agencies.client';
import { defaultPartnershipTemplates } from './defaultPartnershipTemplates';

export const buildState = (details?: PartnershipDetails): PartnershipDetails => {
  if (!details) {
    return {
      partnershipAgreement: {
        customized: false,
        partnershipTiers: defaultPartnershipTemplates.map((tier) => ({
          ...tier,
        })),
      },
    };
  }
  return {
    ...details,
    partnershipAgreement: {
      ...details.partnershipAgreement,
      partnershipTiers:
        (details.partnershipAgreement?.partnershipTiers?.length ?? 0) > 0
          ? details.partnershipAgreement?.partnershipTiers
          : defaultPartnershipTemplates.map((tier) => ({ ...tier })),
    },
  };
};
